import type { IConfig } from '@cian/config/shared';
import type { ISearchOffersDesktopResponseV2Schema } from 'shared/repositories/search-offers/entities/entities/SearchOffersDesktopResponseV2Schema';

/* istanbul ignore next */
export function mockChats(response: ISearchOffersDesktopResponseV2Schema, config?: IConfig) {
  if (config?.get<boolean>('newbuildingChatsEnabled') && response.data.newbuilding) {
    const newbuilding = response.data.newbuilding;

    newbuilding.builders.forEach(builder => {
      builder.chat = {
        isEnabled: true,
        defaultMessage:
          'Здравствуйте! Я пишу по ЖК Цветочки по адресу Профсоюзная 50 в Москве.\nhttps://zhk-akzent-spb-i.cian.ru/',
        // @ts-expect-error Удалится в CD-245836
        entityId: '123_456',
        context: { newbuildingId: newbuilding.id },
      };
    });
    newbuilding.sellers.forEach(seller => {
      // @ts-expect-error Удалится в CD-245836
      seller.chat = {
        isEnabled: true,
        defaultMessage:
          'Здравствуйте! Я пишу по ЖК Цветочки по адресу Профсоюзная 50 в Москве.\nhttps://zhk-akzent-spb-i.cian.ru/',
        entityId: '123_456',
        context: { newbuildingId: newbuilding.id },
      };
    });
  }
}
